import { render, staticRenderFns } from "./RoutingSidebar.vue?vue&type=template&id=31e1a154&scoped=true"
import script from "./RoutingSidebar.vue?vue&type=script&lang=js"
export * from "./RoutingSidebar.vue?vue&type=script&lang=js"
import style0 from "./RoutingSidebar.vue?vue&type=style&index=0&id=31e1a154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1a154",
  null
  
)

export default component.exports